import {PinIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {UnpinnedEventNode} from './issue-viewer-page-query-types'
import {TimelineRow} from './row/TimelineRow'

export type UnpinnedEventFragment = Pick<UnpinnedEventNode, 'actor' | 'createdAt' | 'databaseId'>

type UnpinnedEventProps = {
  queryRef: UnpinnedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function UnpinnedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: UnpinnedEventProps): React.ReactElement {
  const {actor, createdAt, databaseId} = queryRef
  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={PinIcon}
    >
      <TimelineRow.Main>{`${LABELS.timeline.unpinned} `}</TimelineRow.Main>
    </TimelineRow>
  )
}
